<template>
  <form class="filter-bar" @submit.prevent>
    <div class="filter-bar__field">
      <label for="fb-state" class="ds-field-label">State</label>
      <select
        id="fb-state"
        class="ds-select"
        :value="filters.state"
        @change="update('state', $event.target.value)"
      >
        <option value="">All states</option>
        <option v-for="s in states" :key="s.code" :value="s.code">
          {{ s.name }}
        </option>
      </select>
    </div>

    <div class="filter-bar__field">
      <label for="fb-level" class="ds-field-label">Level</label>
      <select
        id="fb-level"
        class="ds-select"
        :value="filters.level"
        @change="update('level', $event.target.value)"
      >
        <option value="">Any level</option>
        <option v-for="l in levels" :key="l.code" :value="l.code">
          {{ l.name }}
        </option>
      </select>
    </div>

    <div class="filter-bar__field">
      <label for="fb-control" class="ds-field-label">Control</label>
      <select
        id="fb-control"
        class="ds-select"
        :value="filters.control"
        @change="update('control', $event.target.value)"
      >
        <option value="">Any control</option>
        <option v-for="c in control" :key="c.code" :value="c.code">
          {{ c.name }}
        </option>
      </select>
    </div>

    <!-- No Classification selector, matching CurriculumFinder. The field is
         populated on a minority of institutions (roughly 32% in CA, 11% in NY,
         5% in MA), so filtering on it silently hid most schools. The column
         stays in the results table, visible where the data exists. -->

    <button
      v-if="hasActiveFilters"
      type="button"
      class="filter-bar__clear"
      @click="clearAll"
    >
      Clear filters
    </button>
  </form>
</template>

<script>
import { states, levels, control } from '@/data/filterOptions';

export default {
  name: 'FilterBar',
  props: {
    // Flat filter model owned by the parent: { state, level, control }.
    // Every filter narrows the already-loaded rows client-side.
    filters: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:filters'],
  data() {
    return { states, levels, control };
  },
  computed: {
    hasActiveFilters() {
      return Object.values(this.filters).some((value) => value);
    },
  },
  methods: {
    update(key, value) {
      this.$emit('update:filters', { ...this.filters, [key]: value });
    },
    clearAll() {
      const cleared = {};
      for (const key of Object.keys(this.filters)) {
        cleared[key] = '';
      }
      this.$emit('update:filters', cleared);
    },
  },
};
</script>

<style scoped>
/* Horizontal filter bar: a wrapping row of labelled selects. Anne wants the
 * filters laid out horizontally with room for several more than shown today,
 * so each field is a fixed-min flex item that wraps to the next line on
 * narrow screens. */
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 16px;
}

.filter-bar__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 180px;
  min-width: 160px;
  max-width: 260px;
}

.filter-bar__clear {
  align-self: flex-end;
  margin-bottom: 10px;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: 13px;
  color: var(--mute);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.filter-bar__clear:hover {
  color: var(--ink);
}

@media (max-width: 640px) {
  .filter-bar__field {
    flex-basis: 100%;
    max-width: none;
  }
}
</style>
